import React from "react";
import { connect } from "react-redux";
import { Button, ValidationGroup } from "devextreme-react";
import TextField from "../../../../../../Shared/fields/TextField";
import DateField from "../../../../../../Shared/fields/DateField";
import RadioGroupfield from "../../../../../../Shared/fields/RadioGroupField";
import { setDataNewComplain, lastStep, nextStep } from "../../actions";

class DatosEnfermedad extends React.PureComponent {
  handleBack = () => {
    this.props.dispatch(lastStep());
  }

  handleNext = (params) => {
    const result = params.validationGroup.validate();
    if (result.isValid) {
      this.props.dispatch(nextStep());
    }
  }

  handleChange = (e) => {
    const jsonData = { ...this.props.jsonData };

    jsonData.formDatosEnfermedad[e.element.id] = e.value;

    this.props.dispatch(setDataNewComplain(jsonData));
  }

  render() {
    const form = { ...this.props.jsonData.formDatosEnfermedad };
    return (
      <ValidationGroup className="row">
        <div className="col-12 newDenuncia-title"> {/* ref={this.topRef}> */}
          <h2>Datos de  la enfermedad</h2>
          <p>Completa los datos para pasar a la siguiente sección</p>
        </div>

        <div className="col-12">
          <TextField
            label="Nombre del puesto de trabajo"
            required
            maxLength={80}
            useInputChange
            id="NombrePuesto"
            onChange={this.handleChange}
            value={form.NombrePuesto}
          />

          <TextField
            label="Descripción del trabajo que realizaba"
            required
            maxLength={200}
            useInputChange
            id="DescripcionTrabajo"
            onChange={this.handleChange}
            value={form.DescripcionTrabajo}
          />

          <DateField
            label="Fecha inicio de síntomas"
            id="FechaInicioSintomas"
            required
            value={form.FechaInicioSintomas}
            onChange={this.handleChange}
            type="date"
          />

          <DateField
            label="Fecha primera exposición al agente sospechoso"
            id="FechaPrimeraExposicion"
            required
            max={form.FechaInicioSintomas}
            value={form.FechaPrimeraExposicion}
            onChange={this.handleChange}
            type="date"
          />

          <TextField
            label="Descripción de síntomas"
            required
            useInputChange
            maxLength={100}
            id="DescripcionSintomas"
            value={form.DescripcionSintomas}
            onChange={this.handleChange}
          />

          <TextField
            label="Partes del cuerpo afectada"
            required
            maxLength={100}
            useInputChange
            id="PartesCuerpo"
            value={form.PartesCuerpo}
            onChange={this.handleChange}
          />

          <RadioGroupfield
            label="¿Existen compañeros de trabajo con los mismos síntomas?"
            required
            items={[{ text: "Si", value: "X" }, { text: "No", value: "N" }]}
            id="ExistenCompanerosSintomas"
            displayExpr="text"
            valueExpr="value"
            value={form.ExistenCompanerosSintomas}
            onChange={this.handleChange}
            layout="horizontal"
          />

          <RadioGroupfield
            label="¿Antecedentes de cuadro previo?"
            required
            items={[{ text: "Si", value: "X" }, { text: "No", value: "N" }]}
            displayExpr="text"
            valueExpr="value"
            id="CuadroPrevio"
            value={form.CuadroPrevio}
            layout="horizontal"
            onChange={this.handleChange}
          />

          <TextField
            label="Agente sospechoso que causa la enfermedad"
            required
            useInputChange
            maxLength={200}
            id="Agente"
            value={form.Agente}
            onChange={this.handleChange}
          />

          <Button text="Volver" className="newDenuncia-back-button" onClick={this.handleBack} />

          <Button
            text="Siguiente"
            type="success"
            className="newDenuncia-next-button"
            onClick={this.handleNext}
            useSubmitBehavior
          />
        </div>
      </ValidationGroup>
    );
  }
}


const mapStateToProps = (state) => ({
  UserInfo: state.userRegister.UserInfo,
  jsonData: state.denuncias.jsonData,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(DatosEnfermedad);
